import { render, staticRenderFns } from "./RemovedCifsOperatorDialog.vue?vue&type=template&id=b18556d8"
import script from "./RemovedCifsOperatorDialog.vue?vue&type=script&lang=js"
export * from "./RemovedCifsOperatorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports